import { AppRoutes } from "@/routes/config";

type StepLink = {
  label: string;
  url: string;
};

type StepItem = {
  title: string;
  content: string[];
  links: StepLink[];
};

export const STEPS_TUTORIAL: StepItem[] = [
  {
    title: "紹介会社情報の入力",
    content: ["紹介会社の基本情報を入力しましょう。入力は任意です。"],
    links: [{ label: "紹介会社情報の編集へ", url: AppRoutes.matchEdit }],
  },
  {
    title: "ユーザー設定の入力",
    content: ["アカウント設定、メール配信設定ができます。"],
    links: [{ label: "ユーザー設定へ", url: AppRoutes.userSettingEdit }],
  },
  {
    title: "企業と求人、人材の登録",
    content: [
      "企業情報、求人情報、および人材（求職者）の情報をデータベースに登録しましょう。",
      "募集中として登録された求人から案件化することで、候補者を当てて面接や内定などの進捗を管理可能になります。",
    ],
    links: [
      { label: "企業の登録へ", url: AppRoutes.companyCreate },
      { label: "求人の登録へ", url: AppRoutes.jobCreate },
      { label: "人材の登録へ", url: AppRoutes.talentCreate },
    ],
  },
  {
    title: "初期設定完了",
    content: [
      "お疲れ様でした。ご不明な点等ございましたら、チャットやお問い合わせページからお問い合わせください。",
      "これら表示が不要であれば、「このチュートリアルを閉じる」を押してください。",
    ],
    links: [],
  },
];
